import { PaginationItemType } from "../../pagination.types";

export const organizerItems = (
  items: PaginationItemType[],
  page: number,
  isMobile = true,
) => {
  if (items.length <= 5) return items;

  let indexs: number[] = [];
  if (isMobile) {
    if (page <= 2) {
      if (page !== 1) indexs.push(page);
      indexs.push(page + 1);
      indexs.push(page + 2);
      if (page !== 2) indexs.push(page + 3);
    } else if (page >= items.length - 1) {
      if (page !== items.length - 1) indexs.push(page - 3);
      indexs.push(page - 2);
      indexs.push(page - 1);
      if (page !== items.length) indexs.push(page);
    } else {
      indexs.push(page - 1);
      indexs.push(page);
      indexs.push(page + 1);
    }
  } else {
    if (page <= 4) {
      indexs = [2, 3, 4, 5, 6];
    } else if (page >= items.length - 3) {
      indexs = [
        items.length - 5,
        items.length - 4,
        items.length - 3,
        items.length - 2,
        items.length - 1,
      ];
    } else {
      indexs.push(page - 2);
      indexs.push(page - 1);
      indexs.push(page);
      indexs.push(page + 1);
      indexs.push(page + 2);
    }
  }

  let newItems: PaginationItemType[] = [];

  if (indexs[0] !== 1) {
    newItems.push(items[0]);
    if (page > (isMobile ? 3 : 4)) newItems.push({ text: "..." });
  }

  newItems = [
    ...newItems,
    ...items.filter((item) => indexs.includes(item.page as number)),
  ];

  if (indexs[indexs.length - 1] !== items[items.length - 1].page) {
    if (page <= items.length - (isMobile ? 3 : 4))
      newItems.push({ text: "..." });
    newItems.push(items[items.length - 1]);
  }

  return newItems;
};
